var _componentFullCalendarBasic = function($context) {
    if (!$().fullCalendar) {
        console.warn('Warning - fullcalendar.min.js is not loaded.');
        return;
    }

    // Basic view       
    ($context instanceof jQuery ? $context.find('.js-fullcalendar-basic') : $('.js-fullcalendar-basic')).each(function() {
        var $me = $(this);
        
        $me.fullCalendar({
            locale: 'pl',
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'month,basicWeek,basicDay'
            },
            editable: true,
            events: {
                url: $me.data('source'),
                type: 'POST',
                error: function() {
                    //alert('BŁĄD: Nie można załadować zdarzeń! Spróbuj odświeżyć stronę - jeśli problem będzie się powtarzał skontaktuj się z administratorem.');
                }
            },
            eventLimit: true,
            isRTL: $('html').attr('dir') == 'rtl' ? true : false
        });
    });
};

function init($context) {
    _componentFullCalendarBasic($context);
}

export const FullCalendarBasic = {
    init
}